import { useEffect, useState } from 'react';

export function TumbleWord({
  tumbleWords,
  leadSentence,
}: {
  tumbleWords: string[];
  leadSentence: string;
}) {
  const [prevWordIndex, setPrevWordIndex] = useState<number | null>(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  // Find the longest word to set a fixed width
  const longestWord = tumbleWords.reduce((a, b) =>
    a.length > b.length ? a : b
  );

  // Rotate through words
  useEffect(() => {
    const interval = setInterval(() => {
      setPrevWordIndex(currentWordIndex);
      setCurrentWordIndex((prev) => (prev + 1) % tumbleWords.length);
    }, 3000); // Change word every 3 seconds

    return () => clearInterval(interval);
  }, [currentWordIndex, tumbleWords.length]);

  return (
    <>
      {leadSentence}{' '}
      <span className="inline-block relative align-bottom h-[1.2em] overflow-visible px-1 text-black dark:text-white">
        {/* Invisible placeholder to establish fixed width based on longest word */}
        <span className="invisible whitespace-nowrap">{longestWord}</span>
        {prevWordIndex !== null && (
          <span
            key={`out-${prevWordIndex}`}
            className="absolute left-0 bottom-0 whitespace-nowrap animate-[tumbleOut_0.6s_ease-in-out_forwards]"
          >
            {tumbleWords[prevWordIndex]}
          </span>
        )}
        <span
          key={`in-${currentWordIndex}`}
          className="absolute left-0 bottom-0 whitespace-nowrap animate-[tumbleIn_0.6s_ease-in-out_forwards]"
        >
          {tumbleWords[currentWordIndex]}
        </span>
      </span>
    </>
  );
}

export function EveryBodyTumbleWord({
  leadSentence = 'Bulk Nutrients is for every',
}: {
  leadSentence?: string;
}) {
  return (
    <TumbleWord
      tumbleWords={['body', 'lift', 'adventure', 'step', 'recovery']}
      leadSentence={leadSentence}
    />
  );
}
